<template>
    <v-row class="gap" justify="center">
        <v-col cols="12" sm="8" md="8" lg="6">
            <div class="question">{{question}}{{required ? ' *' : ''}}</div>
            <v-textarea
                outlined
                name="input-7-4"
                :value="answer"
                hide-details
                :rules="rules"
                @input="inputAnswer"
                :maxlength="max_words"
            ></v-textarea>
            <div class="word-counts small-text">
                <div>{{answerLength}}</div>
                <div>characters: {{answer ? answer.length : 0}}</div>
            </div>
            <div class="small-text" v-html="helper_text"></div>
        </v-col>
    </v-row>
</template>
<script>
// import axios from 'axios'
// import Client from '../client.js';

export default {
    props: {
       question: String,
       answer: String,
       min_words: Number,
       max_words: Number,
       helper_text: String,
       required: Boolean,
       qid: String,
    },
    computed: {
        answerLength() {
            if(this.min_words && this.max_words) {
                return `Answer length: ${this.min_words} min - ${this.max_words} max (characters)`;
            }
            if(this.max_words) {
                return `Answer length: ${this.max_words} max (characters)`;
            }
            if(this.min_words) {
                return `Answer length: ${this.min_words} min (characters)`;
            }
            return ''
        },
        rules() {
            return [v => {
                if(!this.required && !v) return true;
                const val = v;
                if(!val) return false;
                return (this.min_words ? val.length >= this.min_words : true) && (this.max_words ? val.length <= this.max_words: true);
            }]
        },
        noRules() {
            return [() => true]
        }
    },
    methods: {
        inputAnswer(v) {
            this.$emit('on-answer', {qid: this.qid, answer: v});
        },
    },
    data: function() {
        return {
            toggle: null,
        }
    },
}
</script>
<style lang="scss" scoped>
.word-counts {
    margin-top: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
.small-text {
    font-family: $helper-font;
    font-size: 12px;
    line-height: 1.5;
}
.question {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 1.25;
}
.gap {
    margin-bottom: 16px;
}
</style>
